// Client wrappers for the dealer-side Org Locations admin surface.
// Discriminated `{ ok: true; data } | { ok: false; error }` shape
// matches the manufacturing client convention so callers can do
//   if (!res.ok) { setError(res.error); return; }
//   useResult(res.data);
//
// The auth-fetch helper is shared with manufacturingClient — it
// attaches the Supabase bearer + X-Workspace-Organization-Id header
// and parses JSON responses. The name `manufacturingFetch` is
// historical; it's effectively the generic workspace API client at
// this point.
import { manufacturingFetch } from "@/lib/manufacturingClient";
import type { OrgLocation, OrgLocationDraft } from "./orgLocationsTypes";

export type OrgLocationsListResponse = {
  ok: true;
  organization_id: string;
  locations: OrgLocation[];
};

export type OrgLocationMutateResponse = {
  ok: true;
  location: OrgLocation;
};

export function listOrgLocationsApi(opts: { includeInactive?: boolean } = {}) {
  return manufacturingFetch<OrgLocationsListResponse>("/api/org/locations/list", {
    method: "POST",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify({ includeInactive: opts.includeInactive === true }),
  });
}

export function createOrgLocationApi(draft: OrgLocationDraft) {
  return manufacturingFetch<OrgLocationMutateResponse>("/api/org/locations/create", {
    method: "POST",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify(draft),
  });
}

export function updateOrgLocationApi(id: string, patch: OrgLocationDraft) {
  return manufacturingFetch<OrgLocationMutateResponse>("/api/org/locations/update", {
    method: "POST",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify({ id, ...patch }),
  });
}

export function deactivateOrgLocationApi(id: string) {
  return updateOrgLocationApi(id, { is_active: false });
}

export function reactivateOrgLocationApi(id: string) {
  return updateOrgLocationApi(id, { is_active: true });
}
